import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    dexports: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_SOURCE_SELECT_IDS (store, ids) {
      store.dexports.selectIds = ids
    },
    REMOVE_SOURCE_SELECT_IDS (store, ids) {
      store.dexports.selectIds = store.dexports.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_SOURCE_SELECT_ID (store, id) {
      store.dexports.selectId = id
    },
    SET_SOURCE_FILTERS (store, filters) {
      store.dexports.filters = filters
    },
    SET_SOURCE_PAGINATE (store, val) {
      store.dexports.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getDexports: (store, getters) => {
      return store.dexports.selectIds.map((id) => {
        return getters['entities/dexports/find'](id)
      })
    },
    getDexportsFilters: (store, getters) => {
      return store.dexports.filters
    },
    getDexportsPaginate: (store, getters) => {
      return store.dexports.paginate
    },
    getDexport: (store, getters) => {
      return getters['entities/dexports/find'](store.dexports.selectId) || {}
    }
  },
  actions: {
    /*
    selectDexports
    */
    selectDexports ({commit, dispatch, getters, state}, filters) {
      return dispatch('getDexports', filters)
      .then((response) => {
        commit('SET_SOURCE_FILTERS', filters)
        commit('SET_SOURCE_PAGINATE', response)
        commit('SET_SOURCE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectDexports
    */
    refreshSelectDexports ({commit, dispatch, getters, state}) {
      return dispatch('selectDexports', getters.getDexportsFilters)
    },
    /*
    selectDexport
    */
    selectDexport ({commit, dispatch, getters, state}, id) {
      return dispatch('getDexportById', id)
      .then((response) => {
        commit('SET_SOURCE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getDexports
    */
    getDexports ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/dexport`, {params: filters})
      .then((response) => {
        return dispatch('entities/dexports/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.dexports || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getDexportById
    */
    getDexportById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/dexport/${id}`)
      .then((response) => {
        return dispatch('entities/dexports/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.dexports[0]
      })
    },
    /*
    createDexport
    */
    createDexport ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/dexport`, data)
      .then((response) => {
        return dispatch('entities/dexports/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.dexports[0]
      })
    },
    /*
    deleteDexport
    */
    deleteDexport ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/dexport/${id}`)
      .then((response) => {
        commit('REMOVE_SOURCE_SELECT_IDS', [id])
        dispatch('entities/dexports/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Dexport.js